import moment from 'moment';
import { DoctorService } from '@/services/doctor.service';
export default {
  props: {
    rowData: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      showDialog: false,
      buttonDisabled: false,
      alert: {
        show: false,
        message: ''
      }
    };
  },
  computed: {
    doctors() {
      return this.rowData.doctorlistdetails || [];
    },
    scheduledWindowLabel() {
      if (!this.rowData.startdatestamp) {
        return '—';
      }
      const start = this.getDateTime(this.rowData.startdatestamp);
      if (!this.rowData.enddatestamp) {
        return start;
      }
      return `${start} – ${this.getDateTime(this.rowData.enddatestamp)}`;
    }
  },
  methods: {
    getDateTime(date) {
      return moment(date * 1000).format('MM/DD/YYYY LTS');
    },
    async confirmCancel() {
      if (this.buttonDisabled) {
        return;
      }
      this.buttonDisabled = true;
      try {
        const {
          data
        } = await DoctorService.cancelReassignment(this.rowData.id);
        if (data) {
          this.$emit('show-toast', 'Reassignment cancelled successfully!');
          this.$emit('refresh');
          this.showDialog = false;
        }
      } catch (e) {
        this.alert = {
          show: true,
          message: e.message
        };
      } finally {
        this.buttonDisabled = false;
      }
    },
    onHide() {
      this.alert = {
        show: false,
        message: ''
      };
      this.buttonDisabled = false;
    }
  }
};